import React from "react";
import NotificationAdminPanel from "@modules/notification/notifi_admin_op_dlg.tsx";

import { logoutKeycloak } from "@core/keycloak/keycloak-config.ts";
import { useMenu } from "@components/MenuContext.tsx";
import { Button } from "primereact/button";

const Navbar: React.FC = () => {
  const { title } = useMenu();

  const handleLogout = () => {
    logoutKeycloak();
  };

  return (
    <header className="w-full h-16 bg-white flex items-center justify-between px-6">
      <div className="title text-xl font-semibold">{title}</div>
      <div className="flex items-center space-x-4">
        <button className="p-2 rounded-full hover:bg-gray-100">
          <NotificationAdminPanel />
        </button>

        <Button onClick={handleLogout}>
          <i className="pi pi-sign-out mr-2" />
          Déconnexion
        </Button>
      </div>
    </header>
  );
};

export default Navbar;
